import type { IconSvgObject } from './types';

const GitCommitIcon: IconSvgObject = [
  ["path", { d: "M12 3.02344L12 8.52344M12 21.0234L12 15.0234", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12.0234", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GitCommitIcon;
